import React from 'react';
import Api from '../../Api.js';
import { ModalContainer, ModalDialog } from 'react-modal-dialog';

export default class PatchPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfirm: false,
      showError: false,
      showMsg: false,
      errorMsg: '',
      source: 'qarepo',
      target: 'qarepo',
      rsource: '',
      rtarget: 'qarepo',
      qarepo: 'null',
      betarepo: 'null',
      prodrepo: 'null',
      backups: [],
    };
  }

  componentDidMount() {
    Api.patchList()
      .then((res) => {
        this.setState({
          qarepo: res.qarepo.createdate,
          betarepo: res.betarepo.createdate,
          prodrepo: res.prodrepo.createdate,
        });
      })
      .catch(() => {
        this.handleShowError('Error, something wrong with patchapi');
      });
    Api.backupList().then((res) => {
      let backups = res.backuplist.backups || [];
      this.setState({ backups: backups });
      if (backups.length > 0) this.setState({ rsource: backups[0] });
    });
  }

  getVersion(repo) {
    Api.getPatchVersion(repo)
      .then((res) => {
        let temp = {};
        temp[repo] = res.data.createdate;
        this.setState(temp);
      })
      .catch(() => {
        this.handleShowError('Error, something wrong with patchapi');
      });
  }

  handleShowError(msg) {
    this.setState({
      showError: true,
      errorMsg: msg,
    });
  }

  changeState(event) {
    let key = event.target.id;
    let value = event.target.value;

    this.setState({ [key]: value });
  }

  handleCloseError() {
    this.setState({
      showError: false,
      errorMsg: '',
    });
  }

  handleCloseModal() {
    this.setState({
      showConfirm: false,
    });
  }

  handleCloseMsgModal() {
    this.setState({
      showMsg: false,
    });
  }

  recoverRepo() {
    if (this.state.rsource != this.state.rtarget && this.state.rsource.length > 0) {
      Api.recover(this.state.rsource, this.state.rtarget)
        .then((res) => {
          if (res.status == 'ok')
            this.setState({
              qarepo: res.qarepo.createdate,
              betarepo: res.betarepo.createdate,
              prodrepo: res.prodrepo.createdate,
            });
          else this.handleShowError(res.msg);
        })
        .catch((res) => {
          this.handleShowError('Error, something wrong with patchapi');
        });
    } else {
      this.handleShowError('Source and target are the same');
    }
  }

  switchRepo() {
    if (this.state.source != this.state.target) {
      Api.switchRepo(this.state.source, this.state.target)
        .then((res) => {
          if (res.status == 'ok')
            this.setState({
              qarepo: res.qarepo.createdate,
              betarepo: res.betarepo.createdate,
              prodrepo: res.prodrepo.createdate,
            });
          else this.handleShowError(res.msg);
        })
        .catch(() => {
          this.handleShowError('Error, something wrong with patchapi');
        });
    } else {
      this.handleShowError('Source and target are the same');
    }
  }

  mirrorRepo() {
    this.setState({
      showMsg: true,
      msg: 'You have kicked in a mirror repo request, it will take approximately one hour and thirty mins to run',
    });
    Api.mirrorRepo().then((res) => {
      if (res.status == 'ok')
        this.setState({
          qarepo: res.qarepo.createdate,
          betarepo: res.betarepo.createdate,
          prodrepo: res.prodrepo.createdate,
        });
      else this.handleShowError(res.msg);
    });
  }

  repoSync() {
    this.handleCloseModal();
    Api.reposync().then((res) => {
      if (res.status == 'ok')
        this.setState({
          qarepo: res.qarepo.createdate,
          betarepo: res.betarepo.createdate,
          prodrepo: res.prodrepo.createdate,
        });
      else this.handleShowError(res.msg);
    });
  }

  render() {
    return (
      <div className='content'>
        <div className='pure-form pure-form-horizontal pure-g'>
          <div className='pure-u-1-5'/>
          <div className='pure-control-group pure-u-3-5' style={{textAlign:'center'}}>
            <div className='pure-u-1-5'><p>QA repo</p></div>
            <div className='pure-u-2-5'><input value={this.state.qarepo} className='pure-input-1' style={{height: '3.3em'}} readOnly={true}/></div>
            <div className='pure-u-2-5'>
              <button className='pure-button pure-button-primary pure-u-1-3' onClick={this.getVersion.bind(this,'qarepo')} style={{margin:'2%'}}>Get Version</button>
              <button className='pure-button pure-button-primary pure-u-1-3' onClick={this.mirrorRepo.bind(this)} style={{margin:'2%'}}>Mirror Repo</button>
            </div>
            <div className='pure-u-2-5'>
              <input
                value={this.state.qarepo}
                className='pure-input-1'
                style={{ height: '3.3em' }}
                readOnly={true}
              />
            </div>
            <div className='pure-u-2-5'>
              <button
                className='pure-button pure-button-primary pure-u-1-3'
                onClick={this.getVersion.bind(this, 'qarepo')}
                style={{ margin: '2%' }}
              >
                Get Version
              </button>
              <button
                className='pure-button pure-button-primary pure-u-1-3'
                onClick={this.mirrorRepo.bind(this)}
                style={{ margin: '2%' }}
              >
                Mirror Repo
              </button>
            </div>
            <div className='pure-u-1-5'>
              <p>Beta repo</p>
            </div>
            <div className='pure-u-2-5'>
              <input
                value={this.state.betarepo}
                className='pure-input-1'
                style={{ height: '3.3em' }}
                readOnly={true}
              />
            </div>
            <div className='pure-u-2-5'>
              <button
                className='pure-button pure-button-primary'
                onClick={this.getVersion.bind(this, 'betarepo')}
              >
                Get Version
              </button>
            </div>
            <div className='pure-u-1-5'>
              <p>Prod repo</p>
            </div>
            <div className='pure-u-2-5'>
              <input
                value={this.state.prodrepo}
                className='pure-input-1'
                style={{ height: '3.3em' }}
                readOnly={true}
              />
            </div>
            <div className='pure-u-2-5'>
              <button
                className='pure-button pure-button-primary'
                onClick={this.getVersion.bind(this, 'prodrepo')}
              >
                Get Version
              </button>
            </div>
          </div>
          <div className='pure-u-1-5' />
        </div>
        <div className='pure-control-group pure-u-1'>
          <div className='pure-u-1-5' />
          <button
            onClick={() => {
              this.setState({ showConfirm: true });
            }}
            style={{ marginTop: '1%', height: '3.6em' }}
            className='pure-button pure-button-primary pure-u-3-5'
          >
            One click create patch cycle
          </button>
          <div className='pure-u-1-5' />
        </div>

        <div className='pure-control-group pure-u-1' style={{ marginTop: '5%' }}>
          <div className='pure-u-1-5' />
          <div className='pure-u-3-5'>
            <div className='pure-u-1-2'>
              <label className='pure-u-1-2' htmlFor='source'>
                Source
              </label>
              <select id='source' className='pure-input-1-2' onChange={this.changeState.bind(this)}>
                <option value='qarepo'>QA Repo</option>
                <option value='betarepo'>BETA Repo</option>
                <option value='prodrepo'>PROD Repo</option>
              </select>
            </div>
            <div className='pure-u-1-2'>
              <label className='pure-u-1-2' htmlFor='target'>
                Target
              </label>
              <select id='target' className='pure-input-1-2' onChange={this.changeState.bind(this)}>
                <option value='qarepo'>QA Repo</option>
                <option value='betarepo'>BETA Repo</option>
                <option value='prodrepo'>PROD Repo</option>
              </select>
            </div>
            <button
              onClick={this.switchRepo.bind(this)}
              style={{ marginTop: '4%', height: '3.6em' }}
              className='pure-button pure-button-primary pure-u-1'
            >
              Replace Repo
            </button>
          </div>
          <div className='pure-u-1-5' />
        </div>

        <div className='pure-control-group pure-u-1' style={{ marginTop: '5%' }}>
          <div className='pure-u-1-5' />
          <div className='pure-u-3-5'>
            <div className='pure-u-1-2'>
              <label className='pure-u-1-2' htmlFor='source'>
                Source
              </label>
              <select
                id='rsource'
                className='pure-input-1-2'
                onChange={this.changeState.bind(this)}
              >
                {this.state.backups.map((value) => {
                  return <option value={value}>{value}</option>;
                })}
              </select>
            </div>
            <div className='pure-u-1-2'>
              <label className='pure-u-1-2' htmlFor='target'>
                Target
              </label>
              <select
                id='rtarget'
                className='pure-input-1-2'
                onChange={this.changeState.bind(this)}
              >
                <option value='qarepo'>QA Repo</option>
                <option value='betarepo'>BETA Repo</option>
                <option value='prodrepo'>PROD Repo</option>
              </select>
            </div>
            <button
              onClick={this.recoverRepo.bind(this)}
              style={{ marginTop: '4%', height: '3.6em' }}
              className='pure-button pure-button-primary pure-u-1'
            >
              Recover from backup
            </button>
          </div>
          <div className='pure-u-1-5' />
        </div>

        {this.state.showConfirm && (
          <ModalContainer>
            <ModalDialog>
              <div>
                <i
                  className='fa fa-exclamation-circle success'
                  style={{ textAlign: 'center', fontSize: '50px', display: 'block' }}
                ></i>
              </div>
              <h1>ARE YOU SURE?</h1>
              <p style={{ textAlign: 'center' }}>
                You're about to create a new patch cycle. It will take a minute to run. Please come
                back to check in a moment.
              </p>
              <button className='pure-button pure-u-1-2' onClick={this.handleCloseModal.bind(this)}>
                CANCEL
              </button>
              <button
                className='pure-button pure-button-primary pure-u-1-2'
                onClick={this.repoSync.bind(this)}
              >
                CONTINUE
              </button>
            </ModalDialog>
          </ModalContainer>
        )}
        {this.state.showError && (
          <ModalContainer onClose={this.handleCloseError.bind(this)}>
            <ModalDialog>
              <h2>
                <i className='fa fa-exclamation-circle danger'></i> ERROR
              </h2>
              <div>{this.state.errorMsg}</div>
            </ModalDialog>
          </ModalContainer>
        )}
        {this.state.showMsg && (
          <ModalContainer>
            <ModalDialog>
              <div>
                <i
                  className='fa fa-exclamation-circle success'
                  style={{ textAlign: 'center', fontSize: '50px', display: 'block' }}
                ></i>
              </div>
              <h1>Success!</h1>
              <p style={{ textAlign: 'center' }}>{this.state.msg}</p>
              <button
                className='pure-button pure-u-1'
                onClick={this.handleCloseMsgModal.bind(this)}
              >
                Confirm
              </button>
            </ModalDialog>
          </ModalContainer>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/PatchPage.js